import { Stack, SimpleGrid, Skeleton, Group, Box } from '@mantine/core'

/**
 * Full dashboard skeleton matching the real layout.
 * Shows immediately while data loads — improves perceived performance.
 */
export function DashboardSkeleton() {
  return (
    <Stack gap="xl">
      {/* Tab bar skeleton */}
      <Group gap="lg">
        <Skeleton width={80} height={32} radius="sm" />
        <Skeleton width={100} height={32} radius="sm" />
        <Skeleton width={70} height={32} radius="sm" />
        <Skeleton width={85} height={32} radius="sm" />
        <Skeleton width={65} height={32} radius="sm" />
      </Group>

      {/* KPI cards row */}
      <SimpleGrid cols={{ base: 1, sm: 2, lg: 4 }} spacing="md">
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} height={100} radius="md" animate />
        ))}
      </SimpleGrid>

      {/* Metric cards row */}
      <SimpleGrid cols={{ base: 1, sm: 2, lg: 4 }} spacing="md">
        {Array.from({ length: 4 }).map((_, i) => (
          <Box
            key={i}
            style={{
              borderLeft: '4px solid var(--ai-border-light)',
              borderRadius: 'var(--mantine-radius-md)',
              padding: 16,
              backgroundColor: 'var(--ai-card-bg)',
            }}
          >
            <Skeleton width="60%" height={14} mb={8} />
            <Skeleton width="40%" height={24} />
          </Box>
        ))}
      </SimpleGrid>

      {/* Charts row */}
      <SimpleGrid cols={{ base: 1, lg: 2 }} spacing="md">
        <Box
          style={{
            borderTop: '3px solid var(--ai-border-light)',
            borderRadius: 'var(--mantine-radius-md)',
            backgroundColor: 'var(--ai-card-bg)',
            border: '1px solid var(--ai-border-light)',
          }}
        >
          <Box style={{ padding: '10px 16px', borderBottom: '1px solid var(--ai-border-light)' }}>
            <Skeleton width={200} height={16} />
          </Box>
          <Box p="md">
            <Skeleton height={220} radius="md" animate />
          </Box>
        </Box>
        <Box
          style={{
            borderTop: '3px solid var(--ai-border-light)',
            borderRadius: 'var(--mantine-radius-md)',
            backgroundColor: 'var(--ai-card-bg)',
            border: '1px solid var(--ai-border-light)',
          }}
        >
          <Box style={{ padding: '10px 16px', borderBottom: '1px solid var(--ai-border-light)' }}>
            <Skeleton width={180} height={16} />
          </Box>
          <Box p="md">
            <Group justify="center" gap="xl">
              <Skeleton height={160} width={160} circle animate />
              <Stack gap="xs">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Group key={i} gap="xs">
                    <Skeleton width={10} height={10} radius={3} />
                    <Skeleton width={60} height={14} />
                    <Skeleton width={24} height={14} />
                    <Skeleton width={80} height={8} radius="xl" />
                  </Group>
                ))}
              </Stack>
            </Group>
          </Box>
        </Box>
      </SimpleGrid>
    </Stack>
  )
}
